import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import { en } from "./locales/en";
import { es } from "./locales/es";
import { zh } from "./locales/zh";
import { isSupportedLanguage, type SupportedLanguage } from "./types";

export const LANGUAGE_STORAGE_KEY = "akin_language";

export function detectLanguage(): SupportedLanguage {
	const stored = localStorage.getItem(LANGUAGE_STORAGE_KEY);
	if (stored && isSupportedLanguage(stored)) return stored;

	for (const lang of navigator.languages ?? [navigator.language]) {
		const code = lang.split("-")[0].toLowerCase();
		if (isSupportedLanguage(code)) return code;
	}

	return "en";
}

export function persistLanguage(lang: SupportedLanguage): void {
	localStorage.setItem(LANGUAGE_STORAGE_KEY, lang);
}

// initImmediate: false makes init synchronous — no flash of untranslated content
i18next.use(initReactI18next).init({
	lng: detectLanguage(),
	fallbackLng: "en",
	initImmediate: false,
	resources: {
		en: { translation: en },
		es: { translation: es },
		zh: { translation: zh },
	},
	interpolation: {
		escapeValue: false,
	},
});

export { i18next };
